import { Formula } from '../../lib/types/models/formula/formula'
import { FormulaInput } from '../../lib/types/models/formula/formula-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateFormula(data: UpdateInput<FormulaInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.formulas.update.url, { id }))
    .patch<Formula, Partial<FormulaInput>>(rest)
}
